export default __webpack_public_path__ + "static/media/Route.dc580fe1.svg";